import { render, staticRenderFns } from "./alerts-expired-report.vue?vue&type=template&id=afd78816&scoped=true"
import script from "./alerts-expired-report.vue?vue&type=script&lang=js"
export * from "./alerts-expired-report.vue?vue&type=script&lang=js"
import style0 from "./alerts-expired-report.vue?vue&type=style&index=0&id=afd78816&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afd78816",
  null
  
)

export default component.exports